import React from 'react';
import styled from 'styled-components';
import { inject, observer, Provider } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import '../uic/TabBarix.css';
import '../uic/Checkbox.css';

import session from '../session';

import StreamModel from '../models/StreamModel';

import StreamModal from '../form/StreamModal';
import Confirmation from '../form/Confirmation';

import Portal from '../uic/Portal';
// import Wizard from '../uic/Wizard';
import Backdrop from '../uic/Backdrop';
import PageModal from '../uic/PageModal';
import Upload from '../uic/Upload';
import Meter from '../uic/Meter';

import FileDownload from 'react-file-download';

import { Label } from '../styledSystem/Text';
import Button from '../uic/Button';
import Section from '../uic/Section';
import Panel from '../uic/Panel';
import { List, LabelRow, LabelRowAudio } from '../uic/list';

function toDb(val) {
    const peak = parseFloat(val, 10) / 32768;
    return 10 * Math.log10(peak ** 2);
}

const StreamPanel = styled(Panel)`
    margin: 5px;
    min-width: 400px;
`;

class Stream extends React.Component {
    state = {
        showPortal: false,
        formErrors: {
            streamname: '',
            inputsource: '',
            inputlevel: '',
            inputchannel: '',
            samplingrate: '',
            audioport: '',
            bitratetype: '',
            url: '',
            icyurl: '',
            mountpoint: '',
            remoteurl: '',
            username: '',
            password: '',
            servertype: '',
            icecastname: '',
            icecastdescription: '',
            icecastgenre: '',
            encodertype: '',
            servertypeselect: ''
        },
        formValid: true,
        buttonState: false,
        hideEdit: true,
        streamurl: '',
        loaddisable: false,
        loadenable: false,
        importPortal: false,
        switched: false,
        showConfirmationFactory: false,
        removestate: false
    };

    loadSwitch = async () => {
        try {
            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'status',
                {}
            ]);
            if (sessionResult[1].streaming === 'enabled') {
                this.setState({ switched: true });
            } else {
                this.setState({ switched: false });
            }
        } catch (err) {
            console.error('Stream load switch:' + err);
        }
    };

    resetSettings = async () => {
        console.log('restore defaults start');
        await this.disableStream();
        this.setState({ buttonState: true });
        try {
            const sessionResult = await session.rpc(
                'call',
                ['', 'instreamer4', 'restore', {}],
                { timeout: 5 * 60000 }
            );

            if (sessionResult[1].status === 'OK') {
                this.setState({
                    buttonState: false,
                    showConfirmationFactory: false
                });
            }
            console.log('restore defaults: reload model after save to UCI');
            this.modelgeneral.load();
        } catch (err) {
            console.log('ERROR', err);
        }
        console.log('restore defaults end');
    };

    triggerMeter = async () => {
        try {
            if (session.user === 'user') {
                //
                this.setState({ hideEdit: true });
            }
            if (session.user === 'admin') {
                //
                this.setState({ hideEdit: false });
            }

            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'status',
                {}
            ]);
            if (sessionResult[1].streaming === 'enabled') {
                const resp = await session.realm.fetch(
                    '/sys/cgi-bin/status.cgi',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Content-Encoding': 'utf-8'
                        }
                    }
                );

                const { left_peak, right_peak } = JSON.parse(resp);

                if (this._meterLeft) {
                    this._meterLeft.trigger(toDb(left_peak));
                }
                if (this._meterRight) {
                    this._meterRight.trigger(toDb(right_peak));
                }
            }
        } catch (err) {
            console.error('triggerMeter:' + err);
        }
    };

    updateState = variableName => {
        this.setState(variableName);
    };

    close = variableClose => {
        this.setState({ [variableClose]: false });
        this.modelgeneral.load();
    };

    paramsStreamSet() {
        let server, servername;

        console.log(
            'this.modelgeneral.servertype=' + this.modelgeneral.servertype
        );
        console.log(
            'this.modelgeneral.servertypeselect=' +
                this.modelgeneral.servertypeselect
        );

        if (this.modelgeneral.servertype.toLowerCase() === 'rtp') {
            console.log('SERVER IS RTP');

            server = {
                rtp_1: {
                    channel_name: this.modelgeneral.streamname,
                    destinations:
                        this.modelgeneral.servertype +
                        '://' +
                        this.modelgeneral.url +
                        ':' +
                        this.modelgeneral.audioport
                }
            };

            servername = 'rtp_1';
        } else if (this.modelgeneral.servertype.toLowerCase() === 'icecast') {
            console.log('SERVER IS ICECAST');

            /*if (this.modelgeneral.servertypeselect === 'server') {
                console.log('ICECAST SERVER => LOCALHOST');

                server = {
                    icecast_1: {
                        mount_point: this.modelgeneral.mountpoint,
                        icy_genre: this.modelgeneral.icecastgenre,
                        icy_name: this.modelgeneral.icecastname,
                        icy_description: this.modelgeneral.icecastdescription,

                        remote_url: 'http://' + this.modelgeneral.remoteurl,
                        port: this.modelgeneral.audioport,
                        user_name: this.modelgeneral.username,
                        password: this.modelgeneral.password
                    }
                };

                servername = 'icecast_1';
            } else if (this.modelgeneral.servertypeselect === 'source') {
                console.log('ICECAST SOURCE => REMOTE');

                server = {
                    icecast_1: {
                        mount_point: this.modelgeneral.mountpoint,
                        icy_genre: this.modelgeneral.icecastgenre,
                        icy_name: this.modelgeneral.icecastname,
                        icy_description: this.modelgeneral.icecastdescription,

                        remote_url: 'http://' + this.modelgeneral.remoteurl,
                        //remote_url: this.modelgeneral.remoteurl,
                        port: this.modelgeneral.audioport,
                        user_name: this.modelgeneral.username,
                        password: this.modelgeneral.password
                    }
                };

                servername = 'icecast_1';
            }*/

            if ((this.modelgeneral.servertypeselect !== 'server') && (this.modelgeneral.servertypeselect !== 'source')){
                console.log('SOMETHING IS WRONG');
            } else {
                if (this.modelgeneral.servertypeselect === 'server') {
                    console.log('ICECAST SERVER => LOCALHOST');
                } else if (this.modelgeneral.servertypeselect === 'source') {
                    console.log('ICECAST SOURCE => REMOTE');
                }
                let remoteUrl = this.modelgeneral.remoteurl;
                if (!((remoteUrl).startsWith('http://'))){
                    remoteUrl = 'http://' + remoteUrl;
                }
                server = {
                    icecast_1: {
                        mount_point: this.modelgeneral.mountpoint,
                        icy_genre: this.modelgeneral.icecastgenre,
                        icy_name: this.modelgeneral.icecastname,
                        icy_description: this.modelgeneral.icecastdescription,

                        remote_url: remoteUrl,
                        port: this.modelgeneral.audioport,
                        user_name: this.modelgeneral.username,
                        password: this.modelgeneral.password
                    }
                };

                servername = 'icecast_1';
            }
        }

        let objt = {
            global: { audio: { adc_gain: '6' } },
            input: {
                channel_1: {
                    channel_name: this.modelgeneral.streamname,
                    input_source: this.modelgeneral.inputsource,
                    input_type: this.modelgeneral.inputlevel,
                    input_channel: this.modelgeneral.inputchannel,
                    sampling_rate: this.modelgeneral.samplingrate
                }
            },
            encoder: {
                enc_1: {
                    channel_name: this.modelgeneral.streamname,
                    type: this.modelgeneral.encodertype,
                    bit_rate_type: this.modelgeneral.bitratetype,
                    // compression_level: this.modelgeneral.audioquality,
                    bit_rate: this.modelgeneral.bitrate
                }
            },
            server,
            connection: {
                conn_1: {
                    channel_name: this.modelgeneral.streamname,
                    input: 'channel_1',
                    output: 'enc_1'
                },
                conn_2: {
                    channel_name: this.modelgeneral.streamname,
                    input: 'enc_1',
                    output: servername
                }
            }
        };

        console.log('paramsStreamSet=' + JSON.stringify(objt));
        return objt;
    }

    save = async () => {
        console.log('ApplyChanges: start');
        try {
            this.setState({ buttonState: true, showPortal: false });

            const objt = this.paramsStreamSet();
            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'set',
                objt
            ]);

            await new Promise(r => setTimeout(r, 5000));

            if (sessionResult[1].status === 'OK') {
                this.setState({ buttonState: false });
            }
            console.log('ApplyChanges: reload model after save to UCI');
            this.modelgeneral.load();
        } catch (err) {
            console.error('ApplyChanges:' + err);
        }
        console.log('ApplyChanges: end');
    };

    enableStream = async () => {
        try {
            this.setState({ loadenable: true });

            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'enable',
                {}
            ]);

            if (sessionResult[1].status === 'OK') {
                this.setState({ switched: true });
            }
        } catch (err) {
            console.error('enableStream:' + err);
        }
    };

    disableStream = async () => {
        try {
            this.setState({ loaddisable: true });

            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'disable',
                {}
            ]);

            if (sessionResult[1].status === 'OK') {
                this.setState({ switched: false });
            }
        } catch (err) {
            console.error('disableStream:' + err);
        }
    };

    openplayerurl = () => {
        window.open(this.modelgeneral.streamurl, '_blank');
    };

    toggleSwitch = () => {
        this.setState(prevState => {
            return {
                switched: !prevState.switched
            };
        });
    };

    exportStream = async () => {
        console.log('Export Stream');
        try {
            const config = await session.realm.fetch('/cgi/rest.cgi', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'call',
                    params: ['', 'instreamer4', 'export', {}]
                })
            });

            FileDownload(config, 'InstreamerICE_config');
        } catch (err) {
            console.error('exportStream:' + err);
        }
    };

    removeStream = async () => {
        try {
            console.log('remove stream');
            this.setState({
                removestate: true
            });

            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'remove',
                {}
            ]);

            if (sessionResult[1].status === 'OK') {
                this.setState({
                    removestate: false
                });
            }
        } catch (err) {
            console.error('removeStream:' + err);
        }
    };

    componentWillMount() {
        const { session } = this.props;

        this.modelgeneral = new StreamModel(session);
        this.modelgeneral.load();
        console.log(this.modelgeneral);

        if (session.user === 'user') {
            //
            this.setState({ hideEdit: true });
        }
        if (session.user === 'admin') {
            //
            this.setState({ hideEdit: false });
        }

        this.loadSwitch();
    }

    componentDidMount() {
        this._timer = setInterval(this.triggerMeter, 500);
    }

    componentWillUnmount() {
        if (this._timer) {
            clearInterval(this._timer);
        }
    }

    renderButtons = () => {
        const model = this.modelgeneral;
        return (
            <Flex style={{ justifyContent: 'space-between' }}>
                <Flex flexDirection="column">
                    <Flex>
                        <Button
                            disabled={
                                this.state.hideEdit || this.state.buttonState
                            }
                            onClick={() =>
                                this.setState({
                                    importPortal: !this.state.importPortal
                                })
                            }
                            icon="cloud_upload"
                        >
                            Import Stream
                        </Button>

                        <Button
                            buttonStyle="secondary"
                            disabled={
                                model.streamname === '' ||
                                this.state.hideEdit ||
                                this.state.buttonState
                            }
                            onClick={this.exportStream}
                            icon="cloud_download"
                        >
                            Export Stream
                        </Button>
                    </Flex>
                    <Flex>
                        <Button
                            buttonStyle="secondary"
                            enabled={!this.state.hideEdit}
                            onClick={this.enableStream}
                            disabled={
                                this.state.hideEdit ||
                                this.state.switched ||
                                this.state.buttonState
                            }
                            icon="volume_up"
                        >
                            Streaming ON
                        </Button>

                        <Button
                            buttonStyle="secondary"
                            disabled={
                                this.state.hideEdit ||
                                !this.state.switched ||
                                this.state.buttonState
                            }
                            enabled={!this.state.hideEdit}
                            onClick={this.disableStream}
                            icon="volume_off"
                        >
                            Streaming OFF
                        </Button>
                    </Flex>
                    <Flex>
                        <Button
                            buttonStyle="secondary"
                            disabled={
                                this.state.hideEdit || this.state.buttonState
                            }
                            enabled={!this.state.hideEdit}
                            onClick={() =>
                                this.setState({
                                    showPortal: !this.state.showPortal
                                })
                            }
                            icon="edit"
                        >
                            Edit
                        </Button>
                        <Button
                            buttonStyle="secondary"
                            disabled={
                                model.streamname === '' || this.state.hideEdit
                            }
                            onClick={this.save}
                            busy={this.state.buttonState}
                            icon="check"
                        >
                            Restart
                        </Button>
                    </Flex>
                </Flex>
                <Flex flexDirection="column">
                    <Button
                        bg="dangerRed"
                        onClick={() =>
                            this.setState({
                                showConfirmationFactory: true
                            })
                        }
                        icon="restore"
                    >
                        Restore defaults
                    </Button>
                </Flex>
            </Flex>
        );
    };

    render() {
        const model = this.modelgeneral;

        if (!model) {
            console.error('Stream model null');
            return null;
        }

        const samplingratecompute = model.samplingrate / 1000;
        const bitratecompute = model.bitrate / 1000;

        let inputchannelreplace = model.inputchannel;
        if (inputchannelreplace === 'stereo') inputchannelreplace = 'Stereo';
        if (inputchannelreplace === 'mono-right')
            inputchannelreplace = 'Mono Right';
        if (inputchannelreplace === 'mono-left')
            inputchannelreplace = 'Mono Left';

        let level = model.inputlevel;
        if (level === 'nominal') level = 'Nominal';
        if (level === 'consumer') level = 'Consumer';

        let source = model.inputsource;
        if (source === 'line-in') source = 'Line-IN';

        let encoder = model.encodertype;
        if (encoder === 'mp3') encoder = 'MP3';
        if (encoder === 'aac') encoder = 'AAC';

        return (
            <div>
                <Section title="Actions" width={1}>
                    {!this.state.hideEdit && this.renderButtons()}
                </Section>

                <Section title="Streaming Overview" width={1}>
                    <Flex
                        flexDirection="column"
                        mb={2}
                        style={{ maxWidth: 400 }}
                    >
                        <Box>
                            <Meter
                                edit={
                                    this.state.showConfirmationFactory ||
                                    this.state.showPortal ||
                                    this.state.importPortal
                                }
                                ref={ref => (this._meterLeft = ref)}
                            />
                        </Box>
                        <Box>
                            <Meter
                                edit={
                                    this.state.showConfirmationFactory ||
                                    this.state.showPortal ||
                                    this.state.importPortal
                                }
                                ref={ref => (this._meterRight = ref)}
                            />
                        </Box>
                    </Flex>
                    <Flex flexWrap="wrap">
                        <StreamPanel title="Stream Name">
                            <List>
                                <LabelRow label="Name">
                                    {model.streamname}
                                </LabelRow>

                                <LabelRow label="Status">
                                    {this.state.switched ? 'RUNNING' : 'OFF'}
                                </LabelRow>

                                {model.remoteurl === '127.0.0.1' && (
                                    <React.Fragment>
                                        <LabelRowAudio label="Listen Online">
                                            {model.streamurl}
                                        </LabelRowAudio>
                                    </React.Fragment>
                                )}
                            </List>
                        </StreamPanel>
                        <StreamPanel title="Inputs" m={1}>
                            <List>
                                <LabelRow label="Source">{source}</LabelRow>

                                <LabelRow label="Level">{level}</LabelRow>
                                <LabelRow label="Channel">
                                    {inputchannelreplace}
                                </LabelRow>
                                <LabelRow label="Rate">
                                    {samplingratecompute} kHz
                                </LabelRow>
                            </List>
                        </StreamPanel>

                        <StreamPanel title="Encoder">
                            <List>
                                <LabelRow label="Type">{encoder}</LabelRow>

                                <LabelRow label="Bitrate Type">
                                    {model.bitratetype}
                                </LabelRow>

                                <LabelRow label="Bitrate">
                                    {bitratecompute} kb/s
                                </LabelRow>
                            </List>
                        </StreamPanel>

                        <StreamPanel title="Streaming Configuration">
                            <List>
                                <LabelRow label="Server Type">
                                    {model.servertype}{' '}
                                    {model.remoteurl === '127.0.0.1'
                                        ? 'Server'
                                        : 'Source'}
                                </LabelRow>
                                {model.remoteurl !== '127.0.0.1' && (
                                    <React.Fragment>
                                        <LabelRow label="Streaming URL">
                                            {model.remoteurl}
                                        </LabelRow>
                                        <LabelRow label="Port">
                                            {model.audioport}
                                        </LabelRow>
                                    </React.Fragment>
                                )}
                                <LabelRow label="Mount Point">
                                    {model.mountpoint}
                                </LabelRow>
                                {model.icecastname && (
                                    <LabelRow label="Name">
                                        {model.icecastname}
                                    </LabelRow>
                                )}
                                {model.icecastdescription && (
                                    <LabelRow label="Description">
                                        {model.icecastdescription}
                                    </LabelRow>
                                )}
                                {model.icecastgenre && (
                                    <LabelRow label="Genre">
                                        {model.icecastgenre}
                                    </LabelRow>
                                )}
                                <LabelRow label="Stream URL">
                                    <a href={model.streamurl} target="_blank">
                                        {model.streamurl}
                                    </a>
                                </LabelRow>
                            </List>
                        </StreamPanel>
                    </Flex>
                </Section>

                <Section title="Help" width={1}>
                    <Label textStyle="labelSmall">
                        <p>
                            <b>Streaming page</b>
                        </p>
                        <p>Use this page to set up your Icecast stream.</p>
                        <p>
                            You may either stream as an Icecast source, meaning
                            that you feed an external Icecast server of your
                            choice. This server is then accessed by the
                            listeners. Alternatively, you may stream to the
                            internal Icecast server, meaning you provide direct
                            stream access to your listeners on your device.
                        </p>
                        <p>
                            The stream configuration is done in three steps:
                            capture - what is your input, how is it processed;
                            encoding - which encoder are you using, how precise
                            is the encoding; streaming - what is your streaming
                            destination, the metadata carried along the stream,
                            etc.
                        </p>
                        <p>
                            <b>Capture options</b>
                        </p>
                        <p>
                            Select the audio input source from mono-left,
                            mono-right or stereo, depending on how you would
                            like to capture the information from the RCA/Cinch
                            connectors. Select the input level in order to
                            adjust the device's dynamic range or, to put it
                            simply, the loudness. Select "Nominal 0dBu" for
                            0.0dBu nominal input level. Select "Consumer -10dBu"
                            for -7.78dBu consumer input level.
                        </p>
                        <p>
                            Select determine the sampling rate - from 22.05 kHz
                            to 48kHz - to influence the audio quality. A higher
                            sampling rate essentially means that more
                            information is recorded.
                        </p>
                        <p>
                            <b>Encoder options</b>
                        </p>
                        <p>Configure the encoding format</p>
                        <p>
                            Select an encoder (either MP3 or AAC), an encoding
                            format (CBR or VBR) and a bitrate to modify the
                            bandwidth and quality of the output. The available
                            options of the bit rate depend on the sampling rate
                            you selected.
                        </p>
                        <p>
                            <b>Streaming options</b>
                        </p>
                        <p>
                            Select a mode - server or source. Selecting "server
                            mode" will direct the stream to the internal Icecast
                            server using a given IP address, port and with a
                            given Icecast username, password. Selecting "source
                            mode" means that you will have to enter the details
                            "destination server" - URL and port - along with
                            username and password to be able to make alterations
                            afterwards. The stream will then be available at the
                            URL consisting of server address, audio port, and
                            mount point.
                        </p>
                        <p>
                            <b>Mountpoint authentication</b>
                        </p>
                        <p>
                            You can implement listener authentication by setting
                            the "Mount Point" field to "authenticate". You will
                            need to open and log in to the Icecast admin Web UI
                            (port 8000) and manage authentication there. For
                            more information, see the Application User Manual.
                        </p>
                        <p>
                            <b>Import/Export</b>
                        </p>
                        <p>
                            If you wish to save a particular stream
                            configuration for later use, click on the "Export
                            Stream" button. This will trigger the download the
                            configuration file called
                            <i> InstreamerICE_config </i>. If you wish to use a
                            configuration you saved previously, click on the
                            "Import button". Wait for the user interface to
                            refresh - about 20 seconds.
                            <br />
                            Note: You may upload a renamed file.
                        </p>
                        <p>
                            <b>Streaming ON/OFF</b>
                        </p>
                        <p>
                            You can pause/stop the streaming by clicking on the
                            "Streaming OFF" button. You will see a change in the
                            "Status" in the "Stream name" column. Switch the
                            stream back on simply by clicking "Streaming ON".
                        </p>
                        <p>
                            <b>Listen Online</b>
                        </p>
                        <p>
                            This player allows you to have a peak at the stream
                            that is provided on the built-in Icecast server.
                            <br />
                            Note: This feature is only available for the
                            "Icecast "Server mode
                        </p>
                    </Label>
                </Section>
                {this.state.importPortal && (
                    <Portal>
                        <Backdrop>
                            <PageModal
                                errorsPage="true"
                                hidebuttons="true"
                                header="Import Stream Configuration"
                                close={() => this.close('importPortal')}
                            >
                                <Upload
                                    streamimport="true"
                                    urllink="/cgi/rest.cgi"
                                    onDone={async () => {
                                        console.log('upload done');
                                        this.close('importPortal');
                                        console.log(
                                            'upload: reload model after save to UCI'
                                        );
                                        this.modelgeneral.load();
                                    }}
                                />
                            </PageModal>
                        </Backdrop>
                    </Portal>
                )}
                {this.state.showPortal && (
                    <Provider model={model}>
                        <PageModal
                            header="Streaming Settings"
                            close={() => this.close('showPortal')}
                        >
                            <StreamModal
                                updateState={this.updateState}
                                statevariable={this.state}
                                onSave={this.save}
                                formValid={this.state.formValid}
                                onClose={() => this.close('showPortal')}
                            />
                        </PageModal>
                    </Provider>
                )}
                {this.state.showConfirmationFactory && (
                    <Portal>
                        <Backdrop>
                            <PageModal
                                errorsPage="true"
                                hidebuttons="true"
                                header="Restore defaults"
                                close={() =>
                                    this.close('showConfirmationFactory')
                                }
                            >
                                <Confirmation
                                    confirm={this.resetSettings}
                                    bodytext="Are you sure you want to reset the streaming settings to default settings?"
                                    confirmText="Yes"
                                    title="Restore defaults"
                                    uploadinprogress={this.state.buttonState}
                                    close={() =>
                                        this.close('showConfirmationFactory')
                                    }
                                />
                            </PageModal>
                        </Backdrop>
                    </Portal>
                )}
            </div>
        );
    }
}

export default inject('session')(observer(Stream));



// WEBPACK FOOTER //
// ./src/pages/Stream.js